module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.reset),
      expression: "reset"
    }]
  }, [(_vm.hasClicked) ? _c('button', {
    staticClass: "btn btn-cancel double-optin-button",
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.button.double_optin')))]) : _c('i', {
    staticClass: "icon yule-icon-trash action-icon delete-icon",
    on: {
      "click": _vm.click
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-761d56c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Specific/DoubleOptInDelete.vue
// module id = 1947
// module chunks = 0